import i18n from '@dms/i18n';

import {FiltersType} from '../../../types/FiltersType';

export type FilterFieldName = Exclude<
  keyof FiltersType,
  'isMarginAbsolute' | 'isPowerInKW' | 'priceRangeVersion' | 'excludeSuspiciousReasons'
>;

export const getFilterSections = () =>
  [
    {
      id: 'seller',
      label: i18n.t('page.filters.labels.seller'),
      fields: [
        'sellerCountry',
        'originCountry',
        'sellerServer',
        'sellerType',
        'auctionType',
        'carStatus',
        'auctionServer',
        'avgNumberAds',
        'address',
        'radius',
      ],
    },
    {
      id: 'statistics',
      label: i18n.t('page.filters.labels.statistics'),
      fields: [
        'priceCZK',
        'margin',
        'daysOnDisplay',
        'liquidity',
        'pricePosition',
        'reclaimableVat',
      ],
    },
    {
      id: 'makesAndModels',
      label: i18n.t('page.filters.labels.makeAndModels'),
      fields: [
        'make',
        'model',
        'vehicleCategory',
        'hideSuspicious',
        'hitlistOnly',
        'hideBlacklist',
      ],
    },
    {
      id: 'specification',
      label: i18n.t('page.filters.labels.specification'),
      fields: [
        'fuelType',
        'transmission',
        'bodyType',
        'year',
        'mileageRange',
        'power',
        'cubicCapacity',
        'numberOfSeats',
        'featureScore',
        'selectedColors',
        'interiorMaterial',
        'vehicleLengthCategory',
        'vehicleHeightCategory',
        'doorCount',
        'drive',
        'adTitle',
        'trimLevels',
      ],
    },
    {id: 'features', label: i18n.t('general.labels.allFeatures'), fields: ['features']},
  ] satisfies {id: string; label: string; fields: FilterFieldName[]}[];

export const getFilterLabels = () =>
  ({
    make: i18n.t('page.filters.labels.makeAndModels'),
    model: i18n.t('page.filters.labels.models'),
    vehicleCategory: i18n.t('entity.sourcing.filters.labels.vehicleCategory'),
    fuelType: i18n.t('entity.vehicle.labels.fuelType'),
    transmission: i18n.t('entity.vehicle.labels.transmission'),
    bodyType: i18n.t('entity.vehicle.labels.bodyType'),
    year: i18n.t('entity.vehicle.labels.year'),
    mileageRange: i18n.t('entity.vehicle.labels.mileageRange'),
    priceCZK: i18n.t('general.labels.priceWithVat'),
    margin: i18n.t('entity.vehicle.labels.margin'),
    marginPercent: i18n.t('entity.vehicle.labels.margin'),
    daysOnDisplay: i18n.t('entity.vehicle.labels.daysOnDisplay'),
    liquidity: i18n.t('entity.vehicle.labels.liquidity'),
    pricePosition: i18n.t('entity.vehicle.labels.pricePosition'),
    reclaimableVat: i18n.t('general.labels.reclaimableVAT'),
    power: i18n.t('entity.vehicle.labels.power'),
    cubicCapacity: i18n.t('entity.vehicle.labels.cubicCapacity'),
    numberOfSeats: i18n.t('entity.vehicle.labels.numberOfSeats'),
    featureScore: i18n.t('entity.vehicle.labels.rankEquipment'),
    selectedColors: i18n.t('general.labels.colors'),
    interiorMaterial: i18n.t('entity.vehicle.labels.interiorMaterial'),
    vehicleLengthCategory: i18n.t('entity.vehicle.labels.vehicleLength'),
    vehicleHeightCategory: i18n.t('entity.vehicle.labels.vehicleHeight'),
    doorCount: i18n.t('entity.vehicle.labels.numberOfDoors'),
    drive: i18n.t('entity.vehicle.labels.driveType'),
    adTitle: i18n.t('entity.vehicle.labels.adTitle'),
    trimLevels: i18n.t('entity.vehicle.labels.featureTiers'),
    features: i18n.t('general.labels.allFeatures'),
    sellerCountry: i18n.t('entity.vehicle.labels.sellerCountry'),
    originCountry: i18n.t('entity.vehicle.labels.countryOfOrigin'),
    sellerServer: i18n.t('page.filters.labels.sellerServer'),
    sellerType: i18n.t('page.filters.labels.sellerType'),
    auctionType: i18n.t('page.filters.labels.auctionType'),
    carStatus: i18n.t('page.filters.labels.carStatus'),
    auctionServer: i18n.t('page.filters.labels.auctionServer'),
    avgNumberAds: i18n.t('entity.warehouse.labels.averageCarsInStock'),
    address: i18n.t('page.filters.labels.location'),
    radius: i18n.t('page.filters.labels.radius'),
    hideSuspicious: i18n.t('entity.sourcing.filters.labels.hideSuspicious'),
    hitlistOnly: i18n.t('entity.sourcing.filters.labels.hitlistOnly'),
    hideBlacklist: i18n.t('entity.sourcing.filters.labels.hideBlacklist'),
  }) satisfies Record<FilterFieldName, string>;
